import { CollezioneItemType } from '@utils/types'
import { FormatsThickness } from '@components/icons'
import { Badge } from '@components/atoms'
import styles from './Formats.module.sass'

interface Props {
  spessoriFormati: CollezioneItemType['spessoriFormati']
  className?: string
}

const Formats = (props: Props) => {
  const { spessoriFormati = [], className = '' } = props

  return spessoriFormati?.length ? (
    <div className={`${styles.root} ${className}`}>
      {spessoriFormati.map((item, index) => (
        <div key={index} className={styles.item}>
          {item.spessore && (
            <h3 className={styles.title}>
              <FormatsThickness className={styles.icon} />
              {item.spessore}
            </h3>
          )}
          <div className={styles.itemContent}>
            {item.formati.length > 0 &&
              item.formati.map((formato, index) => {
                if (formato && formato?.lato1Intero)
                  return (
                    <Badge
                      content={`${formato?.lato1Intero}<sup>${formato?.lato1Numeratore}/${formato?.lato1Denominatore}"</sup>x ${formato?.lato2Intero}<sup>${formato?.lato2Numeratore}/${formato?.lato2Denominatore}"</sup>`}
                      key={index}
                    />
                  )
                else return <Badge label={formato.nome} key={index} />
              })}
          </div>
        </div>
      ))}
    </div>
  ) : (
    <></>
  )
}

export default Formats
